<template>
	<div class="preview" :class="'preview_length' + (workbench.worktopLength || 'None') + ' preview_weight' + workbench.weight + ' preview_worktopMaterial' + workbench.worktopMaterial">
		<div class="preview-container">
			<div class="preview-top">
				<div v-if="workbench.lighting" class="preview-lighting">
					<div class="preview-lighting1"></div>
					<div class="preview-lighting2"></div>
					<div class="preview-lighting3">
						<div class="preview-dot" @click="showModal('lighting')"></div>
					</div>
					<div class="preview-lighting4"></div>
					<div class="preview-lighting5"></div>
				</div>
				<div v-if="workbench.shield === 2" class="preview-shield preview-shield_second">
					<div class="preview-dot" @click="showModal('shield')"></div>
					<div class="preview-shield1"></div>
					<div class="preview-shield2"></div>
					<div class="preview-shield3"></div>
				</div>
				<div v-if="workbench.shield" class="preview-shield preview-shield_first">
					<div class="preview-dot" @click="showModal('shield')"></div>
					<div class="preview-shield1"></div>
					<div class="preview-shield2"></div>
					<div class="preview-shield3"></div>
				</div>
			</div>
			<div class="preview-tabletop">
				<div class="preview-dot" v-if="workbench.worktopMaterial" @click="showModal('tabletop')"></div>
				<div class="preview-tabletop1"></div>
				<div class="preview-tabletop2"></div>
				<div class="preview-tabletop3"></div>
			</div>
			<div class="preview-bottom">
				<div class="preview-stand" :class="'preview-stand_' + leftStand">
					<div class="preview-dot" @click="showModal('leftStand')"></div>
				</div>
				<div class="preview-wall" :class="{'preview-wall_none': !hasShelf && !hasAmplifier, 'preview-wall_amplifier': hasAmplifier}">
					<div class="preview-dot" v-if="!hasAmplifier" @click="showModal(hasAmplifier ? 'amplifier' : 'shelf')"></div>
				</div>
				<div class="preview-stand" :class="'preview-stand_' + rightStand">
					<div class="preview-dot" @click="showModal('rightStand')"></div>
				</div>
				<template v-if="hasThirdStand">
					<div class="preview-wall" :class="{'preview-wall_none': !hasShelf && !hasAmplifier, 'preview-wall_amplifier': hasAmplifier}">
						<div class="preview-dot" v-if="!hasAmplifier" @click="showModal(hasAmplifier ? 'amplifier' : 'shelf')"></div>
					</div>
					<div class="preview-stand" :class="'preview-stand_' + rightStand">
						<div class="preview-dot" @click="showModal('rightStand')"></div>
					</div>
				</template>
			</div>
		</div>

		<div class="modal" v-if="modalOption" @click.self="closeModal">
			<div class="modal-dialog">
				<div class="modal-header">
					<div class="modal-title">{{ modalOption.text }}</div>
					<div class="modal-close" @click="closeModal"></div>
				</div>
				<div class="modal-body">
					<img v-if="modalOption.image" :src="modalOption.image" alt="">
					<div class="modal-content" v-html="modalOption.description"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { defineComponent, ref, computed } from '@vue/composition-api'
import logic from '../logic';

function stand(base, stand) {
	switch (stand) {
		case 'Тумба Expert WS-1':
			return 'ws1';
		case 'Тумба Expert WS-6':
			return 'ws6';
		case 'Тумба Profi WD-1':
			return 'wd1';
		case 'Тумба Profi WD-2':
			return 'wd2';
		case 'Тумба Profi WD-5':
			return 'wd5';
		case 'Тумба Profi M-1':
			return 'm1';
		case 'Тумба Profi M-4':
			return 'm4';
		case 'Тумба Profi M-5':
			return 'm5';
		case 'Тумба Expert T-1':
			return 't1';
		case 'Тумба Expert T-6':
			return 't6';
		case 'Опора Profi WF-1':
			return 'wf1';
		case 'Опора Expert WF-1':
			return 'wf1';
		case 'Опора Expert WF-2':
			return 'wf2';
		case 'Опора регулируемая Expert WF-2':
			return 'wf2';
		case 'Опора Profi M':
			return 'm';
	}

	return 'none';
}

export default defineComponent({
	props: {
		workbench: {
			type: Object,
			required: true,
		},
	},
	setup(props) {
		const leftStand = computed(() => stand(props.workbench.leftBase, props.workbench.leftStand));
		const rightStand = computed(() => stand(props.workbench.rightBase, props.workbench.rightStand));
		const hasShelf = computed(() => logic.hasShelf(props.workbench));
		const hasThirdStand = computed(() => logic.hasThirdStand(props.workbench));
		const hasAmplifier = computed(() => logic.hasAmplifier(props.workbench));
		const modalOption = ref(null);
		const closeModal = () => modalOption.value = null;
		const showModal = (part) => {
			modalOption.value = logic.getOptions(props.workbench)[part]
		};

		return {
			leftStand,
			rightStand,
			hasShelf,
			hasThirdStand,
			hasAmplifier,
			modalOption,
			closeModal,
			showModal,
		};
	},
})
</script>

<style lang="scss" scoped>
	@use 'sass:math';

	.preview {
		$width: 320px;
		$height: 306px;

		&-container {
			position: relative;
			margin: auto;
			width: $width;
		}

		&-dot {
			position: absolute;
			z-index: 100;
			left: 50%;
			top: 50%;
			margin-left: -8px;
			margin-top: -8px;
			width: 16px;
			height: 16px;
			background: #0B53B3;
			background-clip: content-box;
			border: 1px solid rgba(255, 255, 255, .5);
			border-radius: 8px;
			cursor: pointer;
		}
		&_lengthNone &-dot,
		&-wall_none &-dot,
		&-stand_none &-dot {
			display: none;
		}

		&-top {
			height: 168px;
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
		}

		&-lighting {
			display: flex;
			margin: 0 1px;
			height: 88px;
		}
		&-lighting1 {
			width: 26px;
			background: url(../assets/preview/lighting1.png) no-repeat;
		}
		&-lighting2 {
			flex-grow: 1;
			background: url(../assets/preview/lighting2.png) repeat-x;
		}
		&-lighting3 {
			position: relative;
			z-index: 1;
			width: 140px;
			height: 11px;
			background: url(../assets/preview/lighting3.png) no-repeat;
		}
		&.preview_length1000 &-lighting3 {
			width: 105px;
		}
		&-lighting4 {
			flex-grow: 1;
			background: url(../assets/preview/lighting4.png) repeat-x right top;
		}
		&-lighting5 {
			width: 27px;
			background: url(../assets/preview/lighting5.png) no-repeat;
		}
		&_weight1500 &-lighting1 {
			width: 28px;
			margin-top: -13px;
			background: url(../assets/preview/lighting1_m.png) no-repeat;
		}
		&_weight1500 &-lighting2 {
			flex-grow: 1;
			background: url(../assets/preview/lighting2_m.png) repeat-x;
		}
		&_weight1500 &-lighting3 {
			width: 150px;
			height: 21px;
			background: url(../assets/preview/lighting3_m.png) no-repeat;
		}
		&_weight1500 &-lighting4 {
			flex-grow: 1;
			background: url(../assets/preview/lighting4_m.png) repeat-x;
		}
		&_weight1500 &-lighting5 {
			width: 28px;
			margin-top: -13px;
			background: url(../assets/preview/lighting5_m.png) no-repeat;
		}
		&_weight3000 &-lighting1 {
			width: 28px;
			margin-top: -13px;
			background: url(../assets/preview/lighting1_m.png) no-repeat;
		}
		&_weight3000 &-lighting2 {
			flex-grow: 1;
			background: url(../assets/preview/lighting2_m.png) repeat-x;
		}
		&_weight3000 &-lighting3 {
			width: 150px;
			height: 21px;
			background: url(../assets/preview/lighting3_m.png) no-repeat;
		}
		&_weight3000 &-lighting4 {
			flex-grow: 1;
			background: url(../assets/preview/lighting4_m.png) repeat-x;
		}
		&_weight3000 &-lighting5 {
			width: 28px;
			margin-top: -13px;
			background: url(../assets/preview/lighting5_m.png) no-repeat;
		}

		&-shield {
			position: relative;
			display: flex;
			margin: 0 1px;
			height: 80px;
		}
		&-shield_second {
			margin-top: -80px;
		}
		&-shield1 {
			width: 11px;
			background: url(../assets/preview/shield1.png) no-repeat;
		}
		&-shield2 {
			flex-grow: 1;
			background: url(../assets/preview/shield2.png) repeat-x;
		}
		&-shield3 {
			width: 10px;
			background: url(../assets/preview/shield3.png) no-repeat;
		}
		&_weight1500 &-shield1 {
			width: 14px;
			background: url(../assets/preview/shield1_m.png) no-repeat;
		}
		&_weight1500 &-shield2 {
			flex-grow: 1;
			background: url(../assets/preview/shield2_m.png) repeat-x;
		}
		&_weight1500 &-shield3 {
			width: 14px;
			background: url(../assets/preview/shield3_m.png) no-repeat;
		}
		&_weight3000 &-shield1 {
			width: 14px;
			background: url(../assets/preview/shield1_m.png) no-repeat;
		}
		&_weight3000 &-shield2 {
			flex-grow: 1;
			background: url(../assets/preview/shield2_m.png) repeat-x;
		}
		&_weight3000 &-shield3 {
			width: 14px;
			background: url(../assets/preview/shield3_m.png) no-repeat;
		}

		&-tabletop {
			position: relative;
			display: flex;
			height: 6px;
		}
		&_lengthNone &-tabletop {
			border: 1px dashed #999999;

			& > * {
				display: none;
			}
		}
		&-tabletop1 {
			width: 2px;
			background: url(../assets/preview/tabletop1.png) no-repeat;
		}
		&-tabletop2 {
			flex-grow: 1;
			background: url(../assets/preview/tabletop2.png) repeat-x;
		}
		&-tabletop3 {
			width: 2px;
			background: url(../assets/preview/tabletop3.png) no-repeat;
		}
		&_weight1500 &-tabletop {
			height: 5px;
		}
		&_weight1500 &-tabletop1 {
			width: 2px;
			background: url(../assets/preview/tabletop1_m.png) no-repeat;
		}
		&_weight1500 &-tabletop2 {
			flex-grow: 1;
			background: url(../assets/preview/tabletop2_m.png) repeat-x;
		}
		&_weight1500 &-tabletop3 {
			width: 2px;
			background: url(../assets/preview/tabletop3_m.png) no-repeat;
		}
		&_worktopMaterialW &-tabletop1,
		&_worktopMaterialW &-tabletop2,
		&_worktopMaterialW &-tabletop3 {
			background: #d1ba9e;
		}

		&_worktopMaterialWT &-tabletop1,
		&_worktopMaterialWT &-tabletop2,
		&_worktopMaterialWT &-tabletop3 {
			//background: #d08e3d;
		}

		&-bottom {
			display: flex;
			margin: 0 2px;
			height: 135px;
		}
		&-stand {
			position: relative;
		}
		&-stand_none {
			width: 8px;
			border: 1px dashed #999999;
		}
		&-stand_wd1 {
			width: 74px;
			background: url(../assets/preview/stand_wd1.png) no-repeat;
		}
		&-stand_wd2 {
			width: 74px;
			background: url(../assets/preview/stand_wd2.png) no-repeat;
		}
		&-stand_wd5 {
			width: 74px;
			background: url(../assets/preview/stand_wd5.png) no-repeat;
		}
		&-stand_ws1 {
			width: 95px;
			background: url(../assets/preview/stand_ws1.png) no-repeat;
			background-size: 100% 100%;
		}
		&-stand_ws6 {
			width: 95px;
			background: url(../assets/preview/stand_ws6.png) no-repeat;
			background-size: 100% 100%;
		}
		&-stand_t1 {
			width: 100px;
			background: url(../assets/preview/stand_t1.png) no-repeat;
			background-size: 100% 100%;
		}
		&-stand_t6 {
			width: 101px;
			background: url(../assets/preview/stand_t6.png) no-repeat;
			background-size: 100% 100%;
		}
		&-stand_m1 {
			width: 97px;
			background: url(../assets/preview/stand_m1.png) no-repeat;
		}
		&-stand_m4 {
			width: 97px;
			background: url(../assets/preview/stand_m4.png) no-repeat;
		}
		&-stand_m5 {
			width: 97px;
			background: url(../assets/preview/stand_m5.png) no-repeat;
		}
		&-stand_wf1 {
			width: 14px;
			background: url(../assets/preview/stand_wf1.png) no-repeat;
		}
		&-stand_wf2 {
			width: 14px;
			background: url(../assets/preview/stand_wf2.png) no-repeat;
		}
		&_weight1500 &-stand_wf1,
		&-stand_m {
			width: 12px;
			background: url(../assets/preview/stand_m.png) no-repeat;
		}
		&-wall {
			position: relative;
			flex-grow: 1;
			height: 89px;
			background: url(../assets/preview/wall.png) repeat-x;
		}
		&_weight1500 &-wall {
			flex-grow: 1;
			height: 65px;
			background: url(../assets/preview/wall_m.png) repeat-x;
		}
		& &-wall_none,
		&_lengthNone &-wall {
			background: transparent;
		}
		& &-wall_amplifier {
			margin-top: 61px;
			height: 14px;
			background: url(../assets/preview/amplifier.png) repeat-x;
		}

		@for $i from 0 through 10 {
			$length: 1000 + $i * 100;

			&_length#{$length} &-container {
				width: $width * math.div($length, 2000) + 4;
			}
		}
	}
</style>